import React from 'react';

import './index.scss';
import { SettingsPanel } from './Settings';

export interface IFooterTab {
    imageSrc: string,
    title: string,
    onClick: (args:any) => void,
    highlight?: boolean,
    isPicker?: boolean,
    disable?:boolean
}

interface ITabs {
    mainTabItems: IFooterTab[],
    overrideStyle?: any,
    settingsTitle?: string,
    children?: any
}

export const Tabs = (props: ITabs) => {
    const { mainTabItems, overrideStyle, settingsTitle, children } = props;

    return (
        <div className="footerMain">
            {settingsTitle && children ? <SettingsPanel title={settingsTitle}>
                {children}
            </SettingsPanel> : null}
            <div className='footerTabs'>
            {mainTabItems.map((item, index) => {
                return (
                    <div key={index} className="tabContainer" >
                        {!item.isPicker ? <button disabled={item.disable} onClick={item.onClick}
                            className={item.highlight ? "highlightedTab" : "tabButtonDiv"}
                            style={{ zIndex: 100 }} >
                            <img src={item.imageSrc} title={item.title} />
                            <span>{item.title}</span>
                            </button> : <div style={{ minWidth: 70, position:'relative' }}>
                                <button className="tabButtonDiv" style={{position:'absolute', top:0, pointerEvents:'none'}}>
                                    <img src={item.imageSrc} title={item.title} />
                                    <span>{item.title}</span>
                                </button>
                            <input disabled={item.disable} id="file" type="file" 
                            accept="image/jpg, image/jpeg, image/png, image/svg+xml, application/pdf"
                                    style={{ zIndex: 999 }} onChange={(event) => {
                                item.onClick(event.target.files);
                            }} />
                        </div>
                        }
                    </div>
                )
            })}
            </div>
        </div>
    )
}